<template>
	<section class="promotions background-light main-content align-center">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>
		<div class="row promotions-row flex-row slide-row">
			<client-only>
				<bc-carousel
					:per-page="1"
					:per-page-custom="[
						[600, 2],
						[800, 3],
						[1024, 4],
					]"
					:pagination-position="'bottom-overlay'"
					:navigation-enabled="true"
					:space-padding="20"
					:scroll-per-page="false"
					:loop="true"
					class="carousel"
				>
					<bc-slide v-for="promoblock in promoblocks" :key="promoblock.ID" class="slick-item">
						<nuxt-link :to="localePath(promoblock.link, $i18n.locale)">
							<div class="slick-slide-content">
								<h3>{{ promoblock.header }}</h3>
								<span>
									{{ promoblock.button }}
									<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
								</span>
							</div>
							<picture>
								<source v-if="promoblock.imageWebp" :srcset="promoblock.imageWebp" type="image/webp" />
								<source :srcset="promoblock.image" />
								<img loading="lazy" :src="promoblock.image" :alt="promoblock.imageAlt" />
							</picture>
						</nuxt-link>
					</bc-slide>
				</bc-carousel>
			</client-only>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	subtitle: { type: String, default: '' },
	promoblocks: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
});
</script>
